import { useEffect, useState } from "react";
import { getCauses } from "../../../api/causeApi";

export type Cause = { id: string } & Record<string, unknown>;

export function useUserCauses(userId?: string) {
  const [causes, setCauses] = useState<Cause[]>([]);

  useEffect(() => {
    if (!userId) {
      setCauses([]);
      return;
    }
    let cancelled = false;
    // One-time fetch, not a live subscription like the old Firestore
    // onSnapshot listener - experience-backend has no real-time push yet.
    getCauses(userId)
      .then((nextCauses) => {
        if (!cancelled) setCauses((nextCauses as Cause[]) || []);
      })
      .catch((error) => {
        console.error("Failed to load causes:", error);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { causes };
}
